/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOLoanApplicationDTO } from '../models/ApiResponseDTOLoanApplicationDTO';
import type { ApiResponseDTOLoanOfferDTO } from '../models/ApiResponseDTOLoanOfferDTO';
import type { ApiResponseDTOLoanSimulationDTO } from '../models/ApiResponseDTOLoanSimulationDTO';
import type { LoanApplicationRecord } from '../models/LoanApplicationRecord';
import type { LoanSimulationRecord } from '../models/LoanSimulationRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LoansApiService {

    /**
     * Post Loan application
     * Apply for a recently simulated loan
     * @param requestBody 
     * @returns ApiResponseDTOLoanApplicationDTO OK
     * @throws ApiError
     */
    public static postLoanApplication(
requestBody: LoanApplicationRecord,
): CancelablePromise<ApiResponseDTOLoanApplicationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/loans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get Loan Offers
     * Retrieve the loan offers that exists for the merchant
     * @returns ApiResponseDTOLoanOfferDTO OK
     * @throws ApiError
     */
    public static getLoanOffer(): CancelablePromise<ApiResponseDTOLoanOfferDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/loans/offer',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Post Loan Simulation
     * Retrieves the simulated rates and amounts that will be charged on a new loan
     * @param requestBody 
     * @returns ApiResponseDTOLoanSimulationDTO OK
     * @throws ApiError
     */
    public static postLoanSimulation(
requestBody: LoanSimulationRecord,
): CancelablePromise<ApiResponseDTOLoanSimulationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/loans/simulation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
